import { IRoute, Routes } from './route';

// menu của root
export const RootRouteMenus: IRoute[] = [
  Routes.HOME,
  Routes.CLOUD,
  { ...Routes.PLAYLIST, children: [Routes.PLAYLIST_LIST, Routes.PLAYLIST_HISTORY] },
  Routes.DEVICE,
  Routes.ACCOUNT,
  Routes.PAYMENT,
  {
    ...Routes.SETTING,
    children: [
      Routes.SETTING_CATEGORY_NEWS,
      Routes.SETTING_SOUND_QUALITY,
      Routes.SETTING_ICECAST,
      Routes.SETTING_PACKAGE,
      Routes.SETTING_ERROR,
      Routes.SETTING_CONFIG,
      {
        ...Routes.SETTING_AREA,
        children: [Routes.SETTING_AREA_PROVINCE, Routes.SETTING_AREA_COMMUNE, Routes.SETTING_AREA_VILLAGE],
      },
    ],
  },
  Routes.LOG,
];

// menu của admin
export const AdminRouteMenus: IRoute[] = [
  Routes.HOME,
  Routes.CLOUD,
  { ...Routes.PLAYLIST, children: [Routes.PLAYLIST_LIST, Routes.PLAYLIST_HISTORY] },
  Routes.DEVICE,
  Routes.PAYMENT,
  {
    ...Routes.SETTING,
    children: [Routes.SETTING_AREA_VILLAGE],
  },
  Routes.LOG,
];
